import { MediaCollection, PaginationParams } from '@arpeggi/shared'

export type GetMediaCollectionParams = Omit<
  PaginationParams<MediaCollection>,
  'user' | 'metadata'
> & {
  search?: string
}
